import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { Context } from "../providers/mainProvider";

export default class PrivateRoute extends Component {
    static contextType = Context;

    componentDidMount() {
        const { setValue } = this.context;
        const storedUser = localStorage.getItem("user");

        if (storedUser) {
            try {
                const user = JSON.parse(storedUser);
                setValue({
                    auth: true,
                    user_role: user.user_role,
                    user_uuid: user.user_uuid || false,
                });
            } catch (e) {
                localStorage.removeItem("user");
            }
        }
    }

    render() {
        const { component: Component, allowedRoles, ...rest } = this.props;
        const { auth, user_role } = this.context;

        if (auth === undefined || user_role === undefined) {
            return <div>Loading...</div>;
        }

        const roleAllowed =
            auth &&
            user_role &&
            allowedRoles
                .map((r) => r.toLowerCase())
                .includes(user_role.toLowerCase());

        if (roleAllowed) {
            return <Component {...rest} />;
        }

        return <Navigate to="/login" replace />;
    }
}
